import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "[CodeWithSwiz 20] Adding Firebase support to useAuth, pt2",
  "description": "Firebase continues to be 💩. No wonder people keep asking for support in useAuth. Almost there ✌️",
  "published": "2021-01-19T00:00:00.000Z",
  "categories": "CodeWithSwiz, Technical, Firebase, useAuth, Livecoding",
  "hero": "./img/screenshot-1611074585283.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Firebase continues to be 💩. No wonder people keep asking for support in `}<a parentName="p" {...{
        "href": "https://useauth.dev"
      }}>{`useAuth`}</a>{`.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`If you do, I’ll switch to useAuth `}<a parentName="p" {...{
          "href": "https://twitter.com/nozzleio"
        }}>{`@nozzleio`}</a></p>{`— Tanner Linsley ⚛️ (@tannerlinsley) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/tannerlinsley/status/1348848141496328192"
      }}>{`January 12, 2021`}</a></blockquote>
    <p><em parentName="p">{`CodeWithSwiz is a weekly live show. Like a podcast with video and fun hacking. Focused on experiments and open source. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Mondays`}</a></em></p>
    <lite-youtube {...{
      "videoid": "GmTd0_2AFc4",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Good progress this week! We got a `}<a parentName="p" {...{
        "href": "https://firebase.google.com/docs/auth/web/firebaseui"
      }}>{`Firebase UI`}</a>{` login dialog to show up 🥳`}</p>
    <p><img parentName="p" {...{
        "src": "/08818728c064342886683fa192a457de/FirebaseUI-login-and-signup-widget493747.gif",
        "alt": "FirebaseUI login and signup widget"
      }}></img></p>
    <p>{`To be honest, I was expecting more from a module that adds 64kB`}<sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup>{` of JavaScript. Guess styles come separately?`}</p>
    <h2 {...{
      "id": "where-we-at"
    }}>{`Where we at`}</h2>
    <p>{`Signup flow ends with an error. Return `}<inlineCode parentName="p">{`false`}</inlineCode>{` from a callback or provide a URL. Documentation mentions both the URL and the callback somewhat off-hand. Hard to find.`}</p>
    <p>{`An `}<a parentName="p" {...{
        "href": "https://github.com/firebase/firebaseui-web/issues/3"
      }}>{`issue from 2016`}</a>{` mentions the URL is required. 5 years later documentation and error message say it isn't. 🥲`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`signInSuccessWithAuthResult: function(authResult, redirectUrl) {
  // User successfully signed in.
  // Return type determines whether we continue the redirect automatically
  // or whether we leave that to developer to handle.
  return true;
},
`}</code></pre>
    <p>{`We do get an earlier error about our callback config. 🤔`}</p>
    <p>{`On the bright side, a user shows up in Firebase. That means login works and useAuth isn't resolving it correctly.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/622b5b636b90fd199398b703c8f0568d/c6720/User-created-in-Firebaseg8d7i9.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "23.318385650224215%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'93\\'%20viewBox=\\'0%200%20400%2093\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M318%209c-2%202-1%2013%201%2014%203%202%2033%201%2034-1%202-1%203-11%201-13h-36\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/622b5b636b90fd199398b703c8f0568d/ca0a1/User-created-in-Firebaseg8d7i9.webp 223w", "/static/622b5b636b90fd199398b703c8f0568d/75680/User-created-in-Firebaseg8d7i9.webp 445w", "/static/622b5b636b90fd199398b703c8f0568d/8d1ba/User-created-in-Firebaseg8d7i9.webp 890w", "/static/622b5b636b90fd199398b703c8f0568d/3838e/User-created-in-Firebaseg8d7i9.webp 1335w", "/static/622b5b636b90fd199398b703c8f0568d/e11e5/User-created-in-Firebaseg8d7i9.webp 1780w", "/static/622b5b636b90fd199398b703c8f0568d/da98d/User-created-in-Firebaseg8d7i9.webp 1922w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/622b5b636b90fd199398b703c8f0568d/e92b6/User-created-in-Firebaseg8d7i9.png 223w", "/static/622b5b636b90fd199398b703c8f0568d/e66bf/User-created-in-Firebaseg8d7i9.png 445w", "/static/622b5b636b90fd199398b703c8f0568d/4ef49/User-created-in-Firebaseg8d7i9.png 890w", "/static/622b5b636b90fd199398b703c8f0568d/4e814/User-created-in-Firebaseg8d7i9.png 1335w", "/static/622b5b636b90fd199398b703c8f0568d/701e9/User-created-in-Firebaseg8d7i9.png 1780w", "/static/622b5b636b90fd199398b703c8f0568d/c6720/User-created-in-Firebaseg8d7i9.png 1922w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/622b5b636b90fd199398b703c8f0568d/4ef49/User-created-in-Firebaseg8d7i9.png",
                "alt": "User created in Firebase",
                "title": "User created in Firebase",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`User created in Firebase`}</figcaption>{`
  `}</figure></p>
    <p>{`Huzzah!`}</p>
    <h2 {...{
      "id": "how-we-got-here"
    }}>{`How we got here`}</h2>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/codewithswiz-19-firebase-auth-support-in-useauth-pt1"
      }}>{`In part 1 of Firebase Auth`}</a>{` we sketched out a new provider for useAuth. Configured imports, initialized FirebaseUI, set up the provider class.`}</p>
    <p>{`This episode we:`}</p>
    <ol>
      <li parentName="ol">{`Improved imports`}</li>
      <li parentName="ol">{`Figured out how to initialize Firebase`}</li>
      <li parentName="ol">{`Discovered the `}<inlineCode parentName="li">{`onAuthStateChange`}</inlineCode>{` observer`}</li>
      <li parentName="ol">{`Got frustrated at Google's SEO where any error message you google points to Firebase docs that `}<em parentName="li">{`do not`}</em>{` mention that error message`}</li>
      <li parentName="ol">{`Fiddled with TypeScript types`}</li>
      <li parentName="ol">{`Fired off the login flow`}</li>
    </ol>
    <h3 {...{
      "id": "improved-imports"
    }}>{`Improved imports`}</h3>
    <p>{`Here's the correct way to import Firebase and the Auth UI.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { auth as FirebaseAuthUI } from "firebaseui";
import Firebase from "firebase/app";
import "firebase/auth";
`}</code></pre>
    <p>{`Firebase is a library from the before times and likes to modify globals. In the name of "making it easy".`}</p>
    <p>{`You import `}<inlineCode parentName="p">{`firebase/auth`}</inlineCode>{` into nothing. Refer to it through the `}<inlineCode parentName="p">{`Firebase`}</inlineCode>{` object.`}</p>
    <p>{`Just like we used to do in 2010 when "JavaScript Bundler" meant `}<em parentName="p">{`"Joe with a pickaxe crafting a giant file with `}<inlineCode parentName="em">{`<script>`}</inlineCode>{` tags in exactly the right sequence"`}</em></p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media1.giphy.com/media/3ornjSL2sBcPflIDiU/giphy-loop.mp4?cid=7cf28b0f5g2rnmranyj5sgkw4gmm3wqvxqz8dxze4np246p7&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h3 {...{
      "id": "correctly-initialize-firebase"
    }}>{`Correctly initialize Firebase`}</h3>
    <p>{`We found the incantantion to init Firebase. You must create an app. A project is not enough.`}</p>
    <p>{`Then you click the app and find a `}<inlineCode parentName="p">{`firebaseConfig`}</inlineCode>{` object.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/8af13bc9f5582010fb36a128186a3804/5148a/Firebase-Config1ga47i.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.73991031390135%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'182\\'%20viewBox=\\'0%200%20400%20182\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M47%2086c0%203%202%204%202%201l1-2v2c0%202%205%203%207%201h1l5%201c5%200%205%200%205-3l-2-2-3%201h-4c-2%201-2%201-2-1s-3-3-5-1c-1%202-1%202-2%201-3-3-3-2-3%202m324%2068l1%206h9v-12h-10v6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8af13bc9f5582010fb36a128186a3804/ca0a1/Firebase-Config1ga47i.webp 223w", "/static/8af13bc9f5582010fb36a128186a3804/75680/Firebase-Config1ga47i.webp 445w", "/static/8af13bc9f5582010fb36a128186a3804/8d1ba/Firebase-Config1ga47i.webp 890w", "/static/8af13bc9f5582010fb36a128186a3804/d565e/Firebase-Config1ga47i.webp 1228w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8af13bc9f5582010fb36a128186a3804/e92b6/Firebase-Config1ga47i.png 223w", "/static/8af13bc9f5582010fb36a128186a3804/e66bf/Firebase-Config1ga47i.png 445w", "/static/8af13bc9f5582010fb36a128186a3804/4ef49/Firebase-Config1ga47i.png 890w", "/static/8af13bc9f5582010fb36a128186a3804/5148a/Firebase-Config1ga47i.png 1228w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8af13bc9f5582010fb36a128186a3804/4ef49/Firebase-Config1ga47i.png",
                "alt": "Firebase Config",
                "title": "Firebase Config",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Firebase Config`}</figcaption>{`
  `}</figure></p>
    <p>{`Don't worry about stealing those secrets, they're for the demo app. I intend to share them with the quick start guide.`}</p>
    <p>{`Use them in the auth provider constructor:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/providers/FirebaseUI.ts
export class FirebaseUI implements AuthProviderClass {
    // ..
    constructor(params: AuthOptions & FirebaseOptions) {
        // ..
        this.firebase = Firebase.initializeApp(
            firebaseConfig,
            "useAuth"
        );
`}</code></pre>
    <p>{`Obvious in retrospect. Surprisingly hard to find.`}</p>
    <p>{`The 2nd argument – `}<inlineCode parentName="p">{`"useAuth"`}</inlineCode>{` – tells Firebase to initialize this as a separate app. Avoid overwriting any global Firebase config you might have.`}</p>
    <p>{`Final API will have to let you choose. 🤔`}</p>
    <h3 {...{
      "id": "onauthstatechange-observer"
    }}><inlineCode parentName="h3">{`onAuthStateChange`}</inlineCode>{` observer`}</h3>
    <p><inlineCode parentName="p">{`onAuthStateChange`}</inlineCode>{` was a great find! Lets you hook into the authentication flow and update your state machine.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/providers/FirebaseUI.ts

this.firebase.auth().onAuthStateChanged(this.onAuthStateChanged);

private onAuthStateChanged(user: Firebase.User) {
    console.log("HAI", user);
}
`}</code></pre>
    <p>{`Start in exploration mode 👉 print current user when state changes. First you get a `}<inlineCode parentName="p">{`null`}</inlineCode>{`, then you go through the signup flow and get ... something.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Wow when Firebase returns the authenticated user in a callback ... I guess *some* of those are user properties 🤨 `}<a parentName="p" {...{
          "href": "https://t.co/0jtGUgjrGI"
        }}>{`pic.twitter.com/0jtGUgjrGI`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1351367255095820291"
      }}>{`January 19, 2021`}</a></blockquote>
    <p>{`Minified private TypeScript fields, `}<a parentName="p" {...{
        "href": "https://twitter.com/_developit/status/1351399122952216576"
      }}>{`I'm told`}</a>{`. You call `}<inlineCode parentName="p">{`.toJSON()`}</inlineCode>{` to get the real value.`}</p>
    <p>{`Reload the page after signup and callback prints this again. Login works 🤘`}</p>
    <p>{`We'll use it next time to update useAuth's understanding of current user.`}</p>
    <h3 {...{
      "id": "fire-off-the-login-flow"
    }}>{`Fire off the login flow`}</h3>
    <p>{`To fire off the login flow you need to pass all the config. Bit weird but sure.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`public authorize() {
    // Open login dialog
    this.dispatch("LOGIN");

    this.ui.start("#firebaseui-auth-container", {
        signInOptions: this.signInOptions,
        signInFlow: "popup",
        signInSuccessWithAuthResult: function(
            authResult: any,
            redirectUrl: string
        ) {
            console.log({ authResult, redirectUrl });

            this.dispatch("AUTHENTICATED", {
                user: this.firebase.auth().currentUser,
                authResult
            });
            return false;
        }
    });
}
`}</code></pre>
    <p>{`useAuth calls this method when user clicks the login button. We put XState into the logging-in state with `}<inlineCode parentName="p">{`dispatch('LOGIN')`}</inlineCode>{` then fire up the UI.`}</p>
    <p><a parentName="p" {...{
        "href": "https://firebase.google.com/docs/auth/web/firebaseui#sign_in"
      }}>{`Full options listed here`}</a>{`, if you scroll down.`}</p>
    <p>{`On success, we print the auth result and current user. Tell useAuth and it handles the UI. Redirecting back to destination or at least re-render.`}</p>
    <p>{`But it never gets there 🤔`}</p>
    <h2 {...{
      "id": "thank-you"
    }}>{`Thank you`}</h2>
    <p>{`Aaaaand I figured out what's wrong! You have to wrap `}<inlineCode parentName="p">{`signInSuccessWithAuthResult`}</inlineCode>{` in a `}<inlineCode parentName="p">{`callbacks:{}`}</inlineCode>{` object. Because of course you do.`}</p>
    <p><img parentName="p" {...{
        "src": "/6b08d53b03b28a5ed0846ad799d43853/%F0%9F%8E%89-it-worksabi714.gif",
        "alt": "🎉 it works"
      }}></img></p>
    <p>{`You're a great rubber ducky my friend.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p><sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup>{` size difference measured by removing imports, deploying to Vercel, and looking at network tab.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      